import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {DeviceNameSetting, DeviceWithUuid} from '../../../afb-api/models/device';

@Component({
  selector: 'awair-device-name-editor-dialog',
  templateUrl: './device-name-editor-dialog.component.html',
  styleUrls: ['./device-name-editor-dialog.component.scss']
})

export class DeviceNameEditorDialogComponent implements OnInit {

  get devices(): DeviceWithUuid[] {
    if (this._devices != null) {
      return this._devices;
    }
  }
  @Input()
  set devices(value: DeviceWithUuid[]) {
    if (value != null) {
      this._devices = [...value];
      this.deviceEntities = value.reduce((acc: {[deviceUuid: string]: DeviceWithUuid}, device: DeviceWithUuid) => {
        return {
          ...acc,
          [device.uuid]: device
        };
      }, {});
      this.isDeviceNameEmpty = this._devices.map((device: DeviceWithUuid) => !device.deviceName);
      this.hasEmpty = this.isDeviceNameEmpty.filter((isDeviceNameEmpty: boolean) => isDeviceNameEmpty).length > 0;
    }
  }
  private _devices: DeviceWithUuid[] = [];
  @Output() save: EventEmitter<DeviceNameSetting[]> = new EventEmitter<DeviceNameSetting[]>();

  deviceEntities: {[deviceUuid: string]: DeviceWithUuid} = {};
  changedDeviceNameMap: {[deviceUuid: string]: string} = {};
  tableColumnHeaders: string[] = [
    '#',
    'Name',
    'Owner',
    'Email'
  ];
  isLoading: boolean = false;
  isChanged: boolean = false;
  hasEmpty: boolean = false;
  isDeviceNameEmpty: boolean[] = [];
  focusedDeviceIndex: number = 0;

  constructor(private myDialogRef: MatDialogRef<DeviceNameEditorDialogComponent>) {
  }

  ngOnInit() {
  }

  onDeviceNameFocus(event: any, focusedIndex: number): void {
    event.target.placeholder = '';
    this.focusedDeviceIndex = focusedIndex;
  }

  onDeviceNameBlur(event: any): void {
    event.target.placeholder = 'Enter device name';
    this.focusedDeviceIndex = null;
  }

  onDeviceNameChange(deviceUuid: string, changedName: string, changedIndex: number) {
    if (this.deviceEntities[deviceUuid].deviceName !== changedName) {
      this.changedDeviceNameMap[deviceUuid] = changedName;
    } else {
      delete this.changedDeviceNameMap[deviceUuid];
    }

    this.isDeviceNameEmpty[changedIndex] = (changedName === '');
    this.hasEmpty = this.isDeviceNameEmpty.filter((isDeviceNameEmpty: boolean) => isDeviceNameEmpty).length > 0;
    this.isChanged = Object.keys(this.changedDeviceNameMap).length > 0;
  }

  onCancel(): void {
    if (!this.isChanged || confirm('Changes will not be saved.\nAre you sure you want to exit?')) {
      this.myDialogRef.close();
    }
  }

  onSave(): void {
    const deviceNameSettings = Object.keys(this.changedDeviceNameMap).reduce((acc: DeviceNameSetting[], deviceUuid: string) => {
      return [
        ...acc,
        {
          deviceUuid,
          name: this.changedDeviceNameMap[deviceUuid]
        }
      ];
    }, []);
    this.save.emit(deviceNameSettings);
  }
}
